import cnnSo from "@/stores/connections"
import metricsSo from "@/stores/connections/metrics"
import viewSetup, { ViewStore } from "@/stores/stacks/viewBase"
import { mixStores, StoreOf } from "@priolo/jon"
import { SORTABLE_PROPERTIES } from "./types"



const setup = {

	state: {
		connectionId: <string>null,
		textSearch: "",

		/** sorting type */
		sort: SORTABLE_PROPERTIES.LAST_ACTIVITY,
		/** if SORT dialog is open */
		sortOpen: false,
		/** sorting order */
		sortIsDesc: true,

		//#region VIEWBASE
		width: 460,
		//#endregion
	},

	getters: {

		//#region VIEWBASE
		getTitle: (_: void, store?: ViewStore) => "CLIENTS",
		getSubTitle: (_: void, store?: ViewStore) => cnnSo.getById((<ClientMetricsStore>store).state.connectionId)?.name ?? "--",
		getSerialization: (_: void, store?: ViewStore) => {
			const state = store.state as ClientMetricsState
			return {
				...viewSetup.getters.getSerialization(null, store),
				connectionId: state.connectionId,
			}
		},
		//#endregion

	},

	actions: {

		//#region VIEWBASE
		setSerialization: (data: any, store?: ViewStore) => {
			viewSetup.actions.setSerialization(data, store)
			const state = store.state as ClientMetricsState
			state.connectionId = data.connectionId
		},
		//#endregion

		async onCreated(_: void, store?: ClientMetricsStore) {
			metricsSo.enable(store.state.connectionId)
		},

		onRemoval(_: void, store?: ViewStore) {
			metricsSo.disable((<ClientMetricsStore>store).state.connectionId)
		},

	},

	mutators: {
		setTextSearch: (textSearch: string) => ({ textSearch }),
		
		setSort: (sort: SORTABLE_PROPERTIES) => ({ sort }),
		setSortOpen: (sortOpen: boolean) => ({ sortOpen }),
		setSortIsDesc: (sortIsDesc: boolean) => ({ sortIsDesc }),
	},
}

const clientMetricsSetup = mixStores(viewSetup, setup)
export interface ClientMetricsStore extends StoreOf<typeof clientMetricsSetup> {}
export type ClientMetricsState = ClientMetricsStore["state"]
export default clientMetricsSetup
